import { CheckOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import { FC } from 'react'
import styled from 'styled-components'

export type StepIndicatorItemProps = {
  title: string
  /**
   * 0부터 시작
   */
  step: number

  /**
   * 활성화 표시 여부
   */
  active?: boolean
  /**
   * 번호 대신 체크 아이콘 표시 여부
   */
  checked?: boolean

  className?: string
}

export const StepIndicatorItem: FC<StepIndicatorItemProps> = ({
  title,
  step,
  active,
  checked,
  className,
}) => {
  return (
    <StepIndicatorItemContainer
      className={classNames(className, {
        active,
        checked,
      })}
    >
      <StepIndicatorItemNumber>
        {checked ? <CheckOutlined /> : step + 1}
      </StepIndicatorItemNumber>
      <StepIndicatorItemTitle>{title}</StepIndicatorItemTitle>
    </StepIndicatorItemContainer>
  )
}

const StepIndicatorItemContainer = styled.div`
  flex: 1 0;

  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;

  /* reset */
  border: none;
  background: none;

  border-radius: 8px;
  padding: 8px 16px;
  color: #53677b;

  transition: background-color 0.2s, color 0.2s;

  &:enabled {
    cursor: pointer;

    &:hover {
      background-color: #f0f2f5;
    }
  }

  &:disabled {
    cursor: default;
  }
`

const StepIndicatorItemNumber = styled.div`
  flex-shrink: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 11px;
  line-height: 11px;
  font-weight: 600;

  border-radius: 9999px;

  width: 22px;
  height: 22px;
  background-color: #dbe2ea;

  transition: background-color 0.2s, color 0.2s;

  .active & {
    background-color: #4276ee;
    color: white;
  }
`

const StepIndicatorItemTitle = styled.div`
  flex-shrink: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 16px;
  line-height: 16px;
  font-weight: 600;

  transition: background-color 0.2s, color 0.2s;

  .active & {
    color: #4276ee;
  }

  @media (max-width: ${({ theme }) => theme.screenMD}px) {
    display: none;
  }
`
